const FOOD_URL = process.env.API_URL + '/health/foodManagement';
const getFoodData = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(FOOD_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const deleteFood = (context, foodId) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(FOOD_URL + '/' + foodId)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addNewFood = (context, food) => {
  return new Promise((resolve, reject) => {
    context.$http.post(FOOD_URL, food)
      .then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const updateFood = (context, food) => {
  return new Promise((resolve, reject) => {
    context.$http.put(FOOD_URL, food)
      .then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getFoodData,
  addNewFood,
  deleteFood,
  updateFood
};



// WEBPACK FOOTER //
// ./src/brand/health/api/foodManager/index.js